import { Component, OnInit } from '@angular/core';

import { SimpleNotification, SimpleNotificationType } from '../models/SimpleNotification.model';
import { SimpleNotificationService } from '../services/SimpleNotification.service';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';

// Reducers
import * as fromCore from '../../../../core/reducers';

// Actions
import * as UiActions from '../../../../core/actions/ui.actions';

@Component({
  moduleId: module.id,
  selector: 'simple-notification',
  templateUrl: 'simple-notification.component.html',
  styleUrls: ['./simple-notification.component.scss']
})
export class SimpleNotificationComponent implements OnInit {
  notifications: SimpleNotification = null;

  public notifications$: Observable<any> = this.store.select(state => state.core.ui.notifications);

  constructor(
    private simpleNotificationService: SimpleNotificationService,
    private store: Store<fromCore.State>
  ) {}

  ngOnInit() { }

  removeNotification(notification: SimpleNotification) {
    this.store.dispatch(new UiActions.RemoveSimpleNotification(notification));
  }

  cssClass(notification: SimpleNotification) {
    if (!notification) {
      return;
    }

    // return css class based on alert type
    switch (notification.type) {
      case SimpleNotificationType.Success:
        return 'notification notification-success';
      case SimpleNotificationType.Error:
        return 'notification notification-danger';
      case SimpleNotificationType.Info:
        return 'notification notification-info';
      case SimpleNotificationType.Warning:
        return 'notification notification-warning';
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/simple-notification/components/simple-notification.component.ts